import {
  DeliveryType,
  PickupDeliveryFeeType,
  TicketStatus
} from 'src/app/models';

interface PickupDeliveryFeeMapperValue {
  type: PickupDeliveryFeeType;
  translationKey: string;
}

type PaymentStatusTranslationKey =
  | 'ticketStatus.open'
  | 'ticketStatus.partialPaid'
  | 'ticketStatus.closed'
  | 'ticketStatus.cancelled'
  | 'ticketStatus.voided';

export class TicketConstant {
  static readonly ABLE_ADD_NEW_ITEM_STATUS = [
    TicketStatus.EMPTY,
    TicketStatus.IN_PROGRESS,
    TicketStatus.FIRED
  ];

  static readonly PICKUP_DELIVERY_FEE_MAPPER: Record<
    DeliveryType,
    PickupDeliveryFeeMapperValue
  > = {
    [DeliveryType.DELIVERY]: {
      type: 'delivery',
      translationKey: 'fees.deliveryFee'
    },
    [DeliveryType.TO_GO]: {
      type: 'pick_up',
      translationKey: 'fees.takeoutFee'
    },
    [DeliveryType.PICK_UP]: {
      type: 'pick_up',
      translationKey: 'fees.pickupFee'
    },
    [DeliveryType.TO_TABLE]: null,
    [DeliveryType.TO_ROOM]: null,
    [DeliveryType.TO_SEAT]: null
  };

  private static readonly DEFAULT_STYLE = {
    backgroundColor: '#e8f5e9',
    color: '#43a047'
  };

  private static readonly CLOSED_STYLE = {
    backgroundColor: '#eceff1',
    color: '#607d8b'
  };

  static readonly TICKET_STATUS_MAPPER: Record<
    TicketStatus,
    {
      paymentStatusTranslationKey: PaymentStatusTranslationKey;
      style?: {
        backgroundColor: string;
        color: string;
      };
    }
  > = {
    [TicketStatus.EMPTY]: {
      paymentStatusTranslationKey: 'ticketStatus.open',
      style: TicketConstant.DEFAULT_STYLE
    },
    [TicketStatus.IN_PROGRESS]: {
      paymentStatusTranslationKey: 'ticketStatus.open',
      style: TicketConstant.DEFAULT_STYLE
    },
    [TicketStatus.ON_HOLD]: {
      paymentStatusTranslationKey: 'ticketStatus.open',
      style: TicketConstant.DEFAULT_STYLE
    },
    [TicketStatus.PARTIAL_PAID]: {
      paymentStatusTranslationKey: 'ticketStatus.partialPaid',
      style: {
        color: '#c68305',
        backgroundColor: 'rgba(237, 181, 64, 0.16)'
      }
    },
    [TicketStatus.PAID]: {
      paymentStatusTranslationKey: 'ticketStatus.open',
      style: TicketConstant.DEFAULT_STYLE
    },
    [TicketStatus.FIRED]: {
      paymentStatusTranslationKey: 'ticketStatus.open',
      style: TicketConstant.DEFAULT_STYLE
    },
    [TicketStatus.CLOSED]: {
      paymentStatusTranslationKey: 'ticketStatus.closed',
      style: TicketConstant.CLOSED_STYLE
    },
    [TicketStatus.MERGED]: {
      paymentStatusTranslationKey: 'ticketStatus.open',
      style: TicketConstant.DEFAULT_STYLE
    },
    [TicketStatus.PARTIAL_REFUND]: {
      paymentStatusTranslationKey: 'ticketStatus.closed',
      style: TicketConstant.CLOSED_STYLE
    },
    [TicketStatus.FULL_REFUND]: {
      paymentStatusTranslationKey: 'ticketStatus.closed',
      style: TicketConstant.CLOSED_STYLE
    },
    [TicketStatus.CANCELLED]: {
      paymentStatusTranslationKey: 'ticketStatus.cancelled',
      style: TicketConstant.DEFAULT_STYLE
    },
    [TicketStatus.VOIDED]: {
      paymentStatusTranslationKey: 'ticketStatus.voided',
      style: {
        backgroundColor: '#feebee',
        color: '#ef5350'
      }
    },
    [TicketStatus.IS_REFUND]: {
      paymentStatusTranslationKey: 'ticketStatus.open',
      style: TicketConstant.DEFAULT_STYLE
    },
    [TicketStatus.TAKEOUT_ORDER_IN_PROGRESS]: {
      paymentStatusTranslationKey: 'ticketStatus.open',
      style: TicketConstant.DEFAULT_STYLE
    }
  };

  static readonly CLOSED_TICKET_STATUS_LIST = [
    TicketStatus.PARTIAL_REFUND,
    TicketStatus.FULL_REFUND,
    TicketStatus.CLOSED,
    TicketStatus.VOIDED,
    TicketStatus.CANCELLED
  ];
}
